import React from "react";
import styled from 'styled-components';
import portfoliopic from '../pictures/portfolio.jpg';

class Portfolio extends React.Component {
render(){
const WORKCOVER = styled.div`
    width: 100%;
    height: 100%;
`;

const TITLE = styled.h1`
    margin: 0;
    padding-top: calc(30px + 8vw);
    padding-bottom: 3vh;
    text-align: center;
    color: black;
`;

const BOX = styled.div`
`;

const IMG = styled.img`
    width: 35%;
    height: 100%;
    display: block;
    margin: 0 auto;
    `;

const CONTENT = styled.div`
    padding: 3em;
`;

const TECH = styled.div`
    color: black;
    font-size:calc(10px + 0.4vw)
`;

const BUTTONS = styled.div`
    display: flex;
    justify-content: space-around;
    text-align:center;
    vertical-align: middle;
`;
const BUTTON = styled.a`
    width: calc(40px + 4vw);
    height: calc(20px + 2.5vw);
    line-height: calc(20px + 2.5vw);
    margin: 1em;
    padding: 0.23em 0.5em;
    font-size:calc(10px + 0.4vw)
    font-weight: bold;
    color: white;
    border-style: none;
    border-radius: 3px;
    text-decoration: none;
    background-color: #0F4137;
`;

return(
<div>
<WORKCOVER>
    <TITLE>YUKI'S PORTFOLIO</TITLE>
    <BOX>
        <IMG src= {portfoliopic} alt=""/>
        <CONTENT>
            <TECH>
            使用技術：<br/>
            HTML/CSS/JavaScript/React.js/react-router/styled-components/Firebase<br/><br/>
            詳細：<br/>
            現在ご覧になっているサイトです。<br/>
            内部でのページ遷移にはreact-routerを使用しています。<br/>
            ヘッダーやボタンなどのCSSはmaterial-UIなどをあえて使わず書いてみました。<br/>
            Firebaseを使ってみたかったのでFirebase Hostingでデプロイしています。<br/>
            </TECH>
            <BUTTONS>
                <BUTTON href = "https://github.com/YukiAmakawa/Portfolio" target="_blank">
                    GitHub
                </BUTTON>
            </BUTTONS>
        </CONTENT>
    </BOX>
</WORKCOVER>
</div>
)}}

export default Portfolio;


// WEBPACK FOOTER //
// ./src/components/Portfolio.js